import { useCallback, useState } from "react";
import {
  Box as MuiBox,
  Stack as MuiStack,
  Typography as MuiTypography,
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import Papa from "papaparse";
import { transformFileData } from "app/shared/utils";
import CSVTable from "./CSVTable";
import UploadToOnCore from "./UploadToOnCore";

const UploadFile = ({ csvType }) => {
  const { t } = useTranslation();
  const [fileData, setFileData] = useState([]);
  const [file, setFile] = useState(null);

  const onDrop = useCallback((files) => {
    if (files.length > 0) {
      Papa.parse(files[0], {
        skipEmptyLines: true,
        complete: (results) => {
          setFileData(transformFileData(results.data));
        },
      });
      setFile(files[0]);
    }
  }, []);

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({
      accept: { "text/csv": [".csv"] },
      onDrop,
    });

  const acceptedFilesItems = acceptedFiles.map((file) => (
    <span key={file.path}>
      {file.path} - {file.size} bytes
    </span>
  ));

  return (
    <MuiStack gap={1} style={{ cursor: "pointer" }}>
      <MuiBox
        {...getRootProps()}
        sx={{
          backgroundColor: "#F4F4F4",
          borderRadius: "8px",
          padding: "6px 10px",
        }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <MuiTypography sx={{ fontSize: "14px" }}>
            {t("ois.upload.dropFile")}
          </MuiTypography>
        ) : (
          <MuiStack>
            <MuiTypography sx={{ fontSize: "14px" }}>
              {t("ois.upload.dragDrop")}
            </MuiTypography>
            <MuiTypography sx={{ fontStyle: "italic", fontSize: "14px" }}>
              {t("ois.upload.note")}
            </MuiTypography>
          </MuiStack>
        )}
      </MuiBox>

      {fileData?.length > 0 && (
        <MuiTypography sx={{ fontSize: "14px" }}>
          {t("ois.upload.fileUploaded")} {acceptedFilesItems}
        </MuiTypography>
      )}

      {fileData?.length > 0 && (
        <MuiStack gap={1.75}>
          <CSVTable inputRecords={fileData} csvType={csvType} />
          <UploadToOnCore csvType={csvType} file={file} />
        </MuiStack>
      )}
    </MuiStack>
  );
};

export default UploadFile;
